export class Filter {
    states : States[];
    rmh : RMH[];
    jobTypes : JobType[];
    brands : Brand[];
    crops : Crop[];
    languages : Language[];
    whLocations : WHLocation[];
    rowCount : number;
    languageMapping : Mapping[];
    mapping : stateMapping[];
}

export class RMH{
    rMHCode : string;
    rMHName : string;
}

export class stateMapping{
    rMHCode : string;
    stateName : string;
    whLocationName : string;
}

export class Mapping{
    languageID : number;
    languageName : string;
    state : string;
}

export class Brand{
    brandID : string;
    brandName : string;
}

export class JobType{
    jobTypeID : number;
    jobTypeName : string;
}

export class Crop{
    cropID : number;
    cropName : string;
}

export class Language{
    languageID : number;
    languageName : string;
}

export class States{
    stateID : string;
    stateName : string;
}

export class WHLocation{
    whLoactionID : number;
    whLocationName : string;
}